import {
  DOCTOR_APPOINTMENTS_REQUEST,
  DOCTOR_APPOINTMENTS_SUCCESS,
  DOCTOR_APPOINTMENTS_FAIL,
  PATIENT_HISTORY_REQUEST,
  PATIENT_HISTORY_SUCCESS,
  PATIENT_HISTORY_FAIL,
  PATIENT_HISTORY_CLEAR,
  MEDICINES_SEARCH_REQUEST,
  MEDICINES_SEARCH_SUCCESS,
  MEDICINES_SEARCH_FAIL,
  DOCTORS_LIST_REQUEST,
  DOCTORS_LIST_SUCCESS,
  DOCTORS_LIST_FAIL,
  MEDICAL_RECORD_CREATE_REQUEST,
  MEDICAL_RECORD_CREATE_SUCCESS,
  MEDICAL_RECORD_CREATE_FAIL,
  MEDICAL_RECORD_CREATE_RESET,
  MEDICAL_RECORD_GET_REQUEST,
  MEDICAL_RECORD_GET_SUCCESS,
  MEDICAL_RECORD_GET_FAIL,
  DOCTOR_STATS_REQUEST,
  DOCTOR_STATS_SUCCESS,
  DOCTOR_STATS_FAIL,
  PATIENT_APPOINTMENTS_SEARCH_REQUEST,
  PATIENT_APPOINTMENTS_SEARCH_SUCCESS,
  PATIENT_APPOINTMENTS_SEARCH_FAIL,
  MEDICAL_RECORD_UPDATE_REQUEST,
  MEDICAL_RECORD_UPDATE_SUCCESS,
  MEDICAL_RECORD_UPDATE_FAIL,
  DOCTOR_COMPLETED_APPOINTMENTS_REQUEST,
    DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS,
    DOCTOR_COMPLETED_APPOINTMENTS_FAIL,
    DOCTOR_ALL_PENDING_REQUEST,
    DOCTOR_ALL_PENDING_SUCCESS,
    DOCTOR_ALL_PENDING_FAIL,
} from "../../constants/doctorConstants/doctorConstants.js";

const initialState = {
  // Appointments
  appointments: [],
  appointmentsLoading: false,
  appointmentsError: null,

  // Patient History
  patientHistory: null,
  patientHistoryLoading: false,
  patientHistoryError: null,

  // Medicines Search
  medicinesSearch: [],
  medicinesSearchLoading: false,
  medicinesSearchError: null,

  // Doctors List
  doctorsList: [],
  doctorsListLoading: false,
  doctorsListError: null,

  // Medical Record Create
  medicalRecordCreated: null,
  medicalRecordCreateLoading: false,
  medicalRecordCreateError: null,

  // Medical Record Get
  currentMedicalRecord: null,
  medicalRecordLoading: false,
  medicalRecordError: null,

  // ✅ NEW: Medical Record Update
  medicalRecordUpdated: null,
  medicalRecordUpdateLoading: false,
  medicalRecordUpdateError: null,

  // Stats
  stats: null,
  statsLoading: false,
  statsError: null,
};

export const doctorReducer = (state = initialState, action) => {
  switch (action.type) {
    // Appointments
    case DOCTOR_APPOINTMENTS_REQUEST:
      return { ...state, appointmentsLoading: true, appointmentsError: null };
    case DOCTOR_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointmentsLoading: false,
        appointments: action.payload,
      };
    case DOCTOR_APPOINTMENTS_FAIL:
      return {
        ...state,
        appointmentsLoading: false,
        appointmentsError: action.payload,
      };

    // ✅ NEW: Patient Appointments Search
    case PATIENT_APPOINTMENTS_SEARCH_REQUEST:
      return {
        ...state,
        searchedAppointmentsLoading: true,
        searchedAppointmentsError: null,
      };
    case PATIENT_APPOINTMENTS_SEARCH_SUCCESS:
      return {
        ...state,
        searchedAppointmentsLoading: false,
        searchedAppointments: action.payload,
      };
    case PATIENT_APPOINTMENTS_SEARCH_FAIL:
      return {
        ...state,
        searchedAppointmentsLoading: false,
        searchedAppointmentsError: action.payload,
      };

    // Patient History
    case PATIENT_HISTORY_REQUEST:
      return {
        ...state,
        patientHistoryLoading: true,
        patientHistoryError: null,
      };
    case PATIENT_HISTORY_SUCCESS:
      return {
        ...state,
        patientHistoryLoading: false,
        patientHistory: action.payload,
      };
    case PATIENT_HISTORY_FAIL:
      return {
        ...state,
        patientHistoryLoading: false,
        patientHistoryError: action.payload,
      };
    case PATIENT_HISTORY_CLEAR:
      return { ...state, patientHistory: null, patientHistoryError: null };

    // Medicines Search
    case MEDICINES_SEARCH_REQUEST:
      return {
        ...state,
        medicinesSearchLoading: true,
        medicinesSearchError: null,
      };
    case MEDICINES_SEARCH_SUCCESS:
      return {
        ...state,
        medicinesSearchLoading: false,
        medicinesSearch: action.payload,
      };
    case MEDICINES_SEARCH_FAIL:
      return {
        ...state,
        medicinesSearchLoading: false,
        medicinesSearchError: action.payload,
      };

    // Doctors List
    case DOCTORS_LIST_REQUEST:
      return { ...state, doctorsListLoading: true, doctorsListError: null };
    case DOCTORS_LIST_SUCCESS:
      return {
        ...state,
        doctorsListLoading: false,
        doctorsList: action.payload,
      };
    case DOCTORS_LIST_FAIL:
      return {
        ...state,
        doctorsListLoading: false,
        doctorsListError: action.payload,
      };

    // Medical Record Create
    case MEDICAL_RECORD_CREATE_REQUEST:
      return {
        ...state,
        medicalRecordCreateLoading: true,
        medicalRecordCreateError: null,
      };
    case MEDICAL_RECORD_CREATE_SUCCESS:
      return {
        ...state,
        medicalRecordCreateLoading: false,
        medicalRecordCreated: action.payload,
      };
    case MEDICAL_RECORD_CREATE_FAIL:
      return {
        ...state,
        medicalRecordCreateLoading: false,
        medicalRecordCreateError: action.payload,
      };
    case MEDICAL_RECORD_CREATE_RESET:
      return {
        ...state,
        medicalRecordCreated: null,
        medicalRecordCreateError: null,
      };

    // Medical Record Get
    case MEDICAL_RECORD_GET_REQUEST:
      return { ...state, medicalRecordLoading: true, medicalRecordError: null };
    case MEDICAL_RECORD_GET_SUCCESS:
      return {
        ...state,
        medicalRecordLoading: false,
        currentMedicalRecord: action.payload,
      };
    case MEDICAL_RECORD_GET_FAIL:
      return {
        ...state,
        medicalRecordLoading: false,
        medicalRecordError: action.payload,
      };

    // ✅ NEW: Medical Record Update
    case MEDICAL_RECORD_UPDATE_REQUEST:
      return {
        ...state,
        medicalRecordUpdateLoading: true,
        medicalRecordUpdateError: null,
      };
    case MEDICAL_RECORD_UPDATE_SUCCESS:
      return {
        ...state,
        medicalRecordUpdateLoading: false,
        medicalRecordUpdated: action.payload,
        currentMedicalRecord: action.payload, // Also update current record
      };
    case MEDICAL_RECORD_UPDATE_FAIL:
      return {
        ...state,
        medicalRecordUpdateLoading: false,
        medicalRecordUpdateError: action.payload,
      };
    // Stats
    case DOCTOR_STATS_REQUEST:
      return { ...state, statsLoading: true, statsError: null };
    case DOCTOR_STATS_SUCCESS:
      return { ...state, statsLoading: false, stats: action.payload };
    case DOCTOR_STATS_FAIL:
      return { ...state, statsLoading: false, statsError: action.payload };
    //New
    case DOCTOR_COMPLETED_APPOINTMENTS_REQUEST:
      return {
        ...state,
        completedAppointmentsLoading: true,
        completedAppointmentsError: null,
      };
    case DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        completedAppointmentsLoading: false,
        completedAppointments: action.payload.appointments,
        completedStats: action.payload.stats,
      };
    case DOCTOR_COMPLETED_APPOINTMENTS_FAIL:
      return {
        ...state,
        completedAppointmentsLoading: false,
        completedAppointmentsError: action.payload,
      };

    case DOCTOR_ALL_PENDING_REQUEST:
      return {
        ...state,
        allPendingLoading: true,
        allPendingError: null,
      };
    case DOCTOR_ALL_PENDING_SUCCESS:
      return {
        ...state,
        allPendingLoading: false,
        allPendingAppointments: action.payload,
      };
    case DOCTOR_ALL_PENDING_FAIL:
      return {
        ...state,
        allPendingLoading: false,
        allPendingError: action.payload,
      };
    default:
      return state;
  }
};
